(() => {
  const selector = '.card--product .card__media img.card__main-image,.card--product .card__media img.card__hover-image';
  const cache = new Map();
  const watched = new WeakSet();
  const bounds = new WeakMap();
  const queue = [];
  let busy = false;
  const resize = new ResizeObserver(entries => entries.forEach(entry => {
    entry.target.querySelectorAll(selector).forEach(img => { if (bounds.has(img)) place(img); });
  }));
  function place(img) {
    const b = bounds.get(img);
    const box = img.closest('.media');
    if (!b || !box || !img.naturalWidth || !box.clientWidth || !box.clientHeight) return;
    const fit = Math.min(box.clientWidth / img.naturalWidth, box.clientHeight / img.naturalHeight);
    const bw = (b.right - b.left) * img.naturalWidth;
    const bh = (b.bottom - b.top) * img.naturalHeight;
    const scale = Math.min(box.clientWidth * .78 / (bw * fit), box.clientHeight * .78 / (bh * fit));
    img.style.setProperty('--atlantic-image-scale', String(scale));
    img.style.setProperty('--atlantic-image-x', ((.5 - (b.left + b.right) / 2) * img.naturalWidth * fit * scale) + 'px');
    img.style.setProperty('--atlantic-image-y', ((.5 - (b.top + b.bottom) / 2) * img.naturalHeight * fit * scale) + 'px');
    img.setAttribute('data-atlantic-bounds', '');
    resize.observe(box);
  }
  async function measure(src) {
    const photo = new Image();
    photo.crossOrigin = 'anonymous';
    photo.src = src;
    await Promise.race([photo.decode(), new Promise((_, reject) => setTimeout(() => reject(new Error('Image timeout')), 5000))]);
    const canvas = document.createElement('canvas');
    const ratio = Math.min(160 / photo.naturalWidth,160 / photo.naturalHeight);
    canvas.width = Math.max(1,Math.round(photo.naturalWidth * ratio));
    canvas.height = Math.max(1,Math.round(photo.naturalHeight * ratio));
    const ctx = canvas.getContext('2d',{willReadFrequently:true});
    ctx.fillStyle = '#fff'; ctx.fillRect(0,0,canvas.width,canvas.height);
    ctx.drawImage(photo,0,0,canvas.width,canvas.height);
    const w=canvas.width,h=canvas.height,p=ctx.getImageData(0,0,w,h).data;
    const corners = [[0,0],[w-1,0],[0,h-1],[w-1,h-1]].map(([x,y]) => {const i=(y*w+x)*4;return [p[i],p[i+1],p[i+2]];});
    const bg=[0,1,2].map(c=>corners.map(v=>v[c]).sort((a,b)=>a-b)[2]);
    if(bg.some(c=>c<225) || corners.some(v=>v.some((c,i)=>Math.abs(c-bg[i])>20))) return null;
    const white=(x,y)=>{const i=(y*w+x)*4; return [0,1,2].every(c=>Math.abs(p[i+c]-bg[c])<=20);};
    let edge=0,total=0;
    for(let x=0;x<w;x++){total+=2; edge+=white(x,0)+white(x,h-1);}
    for(let y=0;y<h;y++){total+=2; edge+=white(0,y)+white(w-1,y);}
    if(edge/total<.93) return null;
    let left=w,right=0,top=h,bottom=0,count=0;
    for(let y=0;y<h;y++) for(let x=0;x<w;x++) if(!white(x,y)){left=Math.min(left,x);right=Math.max(right,x+1);top=Math.min(top,y);bottom=Math.max(bottom,y+1);count++;}
    if(count<20 || right-left<w*.08 || bottom-top<h*.08) return null;
    return {left:Math.max(0,left-2)/w,right:Math.min(w,right+2)/w,top:Math.max(0,top-2)/h,bottom:Math.min(h,bottom+2)/h};
  }
  async function process() {
    if(busy || !queue.length) return;
    busy=true;
    const img=queue.shift();
    const src=img.currentSrc || img.src;
    try {
      if(!cache.has(src)) cache.set(src,measure(src).catch(()=>null));
      const b=await cache.get(src);
      if(b && img.isConnected && src===(img.currentSrc || img.src)){bounds.set(img,b);place(img);}
    } catch {}
    busy=false;
    if(queue.length) schedule();
  }
  function schedule(){ if('requestIdleCallback' in window) requestIdleCallback(process,{timeout:1500}); else setTimeout(process,50); }
  const view=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(!entry.isIntersecting) return;
    const img=entry.target;view.unobserve(img);
    const ready=()=>{
      bounds.delete(img);
      img.removeAttribute('data-atlantic-bounds');
      if(img.naturalWidth > 8 && !queue.includes(img)){queue.push(img);schedule();}
    };
    img.addEventListener('load',ready);
    if(img.complete && img.naturalWidth) ready();
  }),{rootMargin:'100px'});
  function watch(root){root.querySelectorAll(selector).forEach(img=>{if(!watched.has(img)){watched.add(img);view.observe(img);}});}
  watch(document);
  new MutationObserver(entries=>entries.forEach(entry=>entry.addedNodes.forEach(node=>{if(node.nodeType===1) watch(node);}))).observe(document.body,{childList:true,subtree:true});
})();